import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-yr3-st-levelbookshelf-b',
  templateUrl: './yr3-st-levelbookshelf-b.component.html',
  styleUrls: ['./yr3-st-levelbookshelf-b.component.scss']
})

export class Yr3StLevelbookshelfBComponent implements OnInit {
  public mydevice: string = "";
  public bloburl: string;

  constructor(private sessionService: SessionService) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;

    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }

  }
}
